import { createFileRoute } from '@tanstack/react-router'
import { PaymentHistoryPage } from '~/features/dashboard/pages/medicals/pages/payment-history'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/medicals/$program/payment-history',
)({
  component: PaymentHistoryPage,
})

